import React from 'react';
import Socialsharing from '../../common/SocialWidget';
import s from './SocialsharingWeb.scss';

class SocialSharingWeb extends React.Component {
  render() {
    return <Socialsharing {...this.props} styles={s} />;
  }
}

export default SocialSharingWeb;
